<template>
    <div class="pp-draw-results-button" data-accordion>
        <button
            class="pp-draw-results-button__collapsible-btn pp-draw-results-button__collapsible-btn--inset"
            :id="id"
            :aria-controls="ariaControls"
        >
            {{ tableTitle }}
            <DsIcon name="arrow-down-thin" :width="16" :height="16" />
        </button>

        <slot></slot>
    </div>
</template>
<script lang="ts" setup>
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";

defineProps<{
    tableTitle: string;
    ariaControls?: string;
    id?: string;
}>();
</script>
